import { useRouter } from "next/router";
import ErrorPage from "next/error";
import Layout from "../../components/layout/layout";
import BlogHeader from "../../components/blogHeader";
import BlogBody from "../../components/blogBody";
import MorePost from "../../components/morePost";
import ShareButton from "../../components/shareButton";
//API
import { getPostBySlug, getMorePosts, getAllPostsWithSlug } from "../../lib";
//STYLES
import { Container, Grid, Typography } from "@material-ui/core";
import useStyles from '../../styles/slugStyles'

export async function getStaticPaths() {
  const allPosts = await getAllPostsWithSlug();
  return {
    paths: allPosts?.map(({ slug }) => `/blog/${slug}`) ?? [],
    fallback: true,
  };
}

export async function getStaticProps({ params }) {
  const post = await getPostBySlug(params.slug);
  const morePosts = await getMorePosts(params.slug);
  return {
    props: {
      post: post ? post : null,
      morePosts: morePosts ? morePosts : null,
    },
    revalidate: 1,
  };
}

export default function Blog(props){

  const { post, morePosts } = props;
  const router = useRouter();
  const classes = useStyles();

  if (!router.isFallback && !post) return <ErrorPage statusCode={404} />
  //console.log('post this', morePosts)
  
  return (
    <Layout
      title={post?.fields.titulo}
      description={post?.fields.subtitulo}
      ogImage={post?.fields.imgenes.fields.file.url}
      url={process.env.NODE_ENV === 'dev' ? `http://localhost:3000/blog/${post?.fields.slug}` : `https://blog.cidu.com.co/blog/${post?.fields.slug}`} /* https://blog.cidu.com.co/ */ >
      <BlogHeader
        title={post?.fields.titulo}
        subtitle={post?.fields.subtitulo}
        authorName={post?.fields.nombre} 
        slug={post?.fields.slug}
        date={post?.fields.fecha}
        coverImage={post?.fields.imgenes.fields.file.url}
      />
      <BlogBody content={post?.fields.contenido} />
      <Container maxWidth="lg" className={classes.container}>
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <Typography align="center" gutterBottom className={classes.shareText} >- Compartir -</Typography>
            <ShareButton  url={process.env.NODE_ENV === 'dev' ? `http://localhost:3000/blog/${post?.fields.slug}` : `https://blog.cidu.com.co/blog/${post?.fields.slug}`}  /* https://blog.cidu.com.co/ */ />
          </Grid>
        </Grid>
        {morePosts && morePosts.length > 0 && <Typography align="center" gutterBottom className={classes.lastPost} > - Publicaciones Recientes - </Typography>}
        <Grid container spacing={4} justify="center">
          {morePosts?.map(({ fields }) => (
            <Grid item key={fields.slug} xs={12} md={4}>
              <Grid container>
                <MorePost
                  title={fields.titulo}
                  subtitle={fields.subtitulo}
                  authorName={fields.nombre} 
                  slug={fields.slug}
                  date={fields.fecha}
                  coverImage={fields.imgenes.fields.file.url}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Layout>
  );
}